import React from 'react'
import './Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopyright } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
  return (
    <>
        <div className="footer-section">
            <div className="footer-social-icons">
                <a href="https://www.linkedin.com/in/mohammed-saqib-756018184" target='_blank' title='LinkedIn'><FontAwesomeIcon icon={faLinkedin} className='socialIcons' size="3x"  /></a>
                <a href="https://github.com/Mohammed-Saqib" target='_blank' title='GitHub'><FontAwesomeIcon icon={faGithub} className='socialIcons' size="3x"  /></a>
                <a href="https://www.instagram.com/saqib_software_developer/" target='_blank' title='Instagram'><FontAwesomeIcon icon={faInstagram} className='socialIcons' size="3x"  /></a>
                <a href="https://wa.me/7406959839" target='_blank' title='WhatsApp'><FontAwesomeIcon icon={faWhatsapp} className='socialIcons' size="3x"  /></a>
            </div>
            <div className="footer-container">
                <FontAwesomeIcon icon={faCopyright} className='footerIcon' size="2x" fade />
                <p className="footer-text">2022 All Rights Reserved To <wbr/>Mohammed Saqib</p>
            </div>
        </div>
    </>
  )
}

export default Footer;